import React, { useEffect, useState } from "react";
import Modal from 'react-modal';
import { MdOutlinePlaylistAdd, MdOutlineDelete } from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { GetAndCreateCategory, GetAndCreateSubCategory } from "../../../../services/ProductService/CategoryMgt/CategoryMgt";
import DeleteCategoryPopUp from "../../../../pages/LADService/AddServices/SAC Mgt/Delete PopUp/DeletePopUp";
import { FaSearch } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

const SelectCategoryModal = ({ onClose, selectedCategory, Category }) => {

    const [categoryData, setCategoryData] = useState([]);
    const [expandedCategoryId, setExpandedCategoryId] = useState(null);
    const [categoryId, setCategoryId] = useState(null);
    const [categoryName, setCategoryName] = useState('');
    const [subcategoryName, setSubCategoryName] = useState('');
    const [showAddSubCategory, setShowAddSubCategory] = useState({});
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [datas, setDatas] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedItem, setSelectedItem] = useState(Category);
    const [loading, setLoading] = useState(false);

    const getCategory = async () => {
        setLoading(true);
        try {
            const categoryResponse = await GetAndCreateCategory("GET", {});
            const subcategoryResponse = await GetAndCreateSubCategory("GET", {});

            const combinedData = categoryResponse.data.map((category) => ({
                ...category,
                subcategories: subcategoryResponse.data.filter(
                    (sub) => sub.category_id === category.id
                ),
            }));
            setCategoryData(combinedData);
        } catch (error) {
            console.error("Failed to fetch categories or subcategories:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleAddSubCategory = async () => {
        if (!subcategoryName) return;
        setLoading(true);
        try {
            const payload = {
                category: categoryId,
                category_name: categoryName,
                name: subcategoryName,
            };
            await GetAndCreateSubCategory("POST", payload);
            getCategory();
            setSubCategoryName('');
        } catch (error) {
            console.error("Failed to add subcategory:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (type, id, name) => {
        setSelectedItem(selectedItem?.id === id ? null : { type, id, name });
        selectedCategory(name)
        onClose()


    };

    const toggleExpand = (categoryId) => {
        setExpandedCategoryId(expandedCategoryId === categoryId ? null : categoryId);
        if (expandedCategoryId === categoryId) {
            setShowAddSubCategory((prev) => ({
                ...prev,
                [categoryId]: false
            }));
        }
    };

    const handleShowAddSubCategory = (categoryId, categoryName) => {
        setCategoryId(categoryId);
        setCategoryName(categoryName);
        if (expandedCategoryId !== categoryId) {
            setExpandedCategoryId(categoryId);
        }
        setShowAddSubCategory((prev) => ({
            ...prev,
            [categoryId]: !prev[categoryId]
        }));
    };

    const handleDelete = (type, id, name) => {
        setShowDeletePopup(true);
        setDatas({ type, id, name });
    };

    const handleDeleteConfirm = () => {
        setShowDeletePopup(false);
        getCategory();
    };

    useEffect(() => {
        getCategory();
    }, []);

    // ✅ Local Search
    const filteredData = categoryData
        .map((category) => ({
            ...category,
            subcategories: category.subcategories.filter((sub) =>
                sub.name.toLowerCase().includes(searchTerm.toLowerCase())
            ),
        }))
        .filter((category) =>
            category.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            category.subcategories.length > 0
        );

    return (
        <div className="relative w-full h-full flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 -mt-96 mb-96 max-w-2xl">
                {/* Header */}
                <div className="flex items-center justify-between py-2 border-b border-gray-300">
                    <div>
                        <h1 className="text-2xl font-bold">Select Category</h1>
                        <p className="text-sm text-gray-500">
                            You can select only one Category or Subcategory.
                        </p>
                    </div>
                    <IoMdClose
                        className="cursor-pointer text-2xl font-bold"
                        onClick={onClose}
                    />
                </div>

                {/* Search */}
                <div className="flex items-center justify-center gap-3 py-5">
                    <div className="relative border w-2/3">
                        <input
                            type="text"
                            placeholder="Search categories or subcategories..."
                            className="rounded-md border-none px-4 py-2 w-full bg-blue-100 outline-blue-100"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <FaSearch className="absolute right-3 top-3 text-gray-500" />
                    </div>
                    <button
                        className="text-blue-700 border border-blue-200 rounded-xl px-5 py-2"
                        onClick={() => setSearchTerm('')}
                    >
                        Clear
                    </button>
                </div>
                {selectedItem && (
                    <div className="flex items-center justify-center">
                        <div className="flex items-center justify-center gap-2 bg-blue-100 px-3 py-1 rounded-md w-fit">
                            <span className="text-blue-700 font-bold">
                                {selectedItem}
                            </span>
                            <IoMdClose
                                className="cursor-pointer"
                                onClick={() => setSelectedItem('')}
                            />
                        </div>
                    </div>
                )}

                {/* Loading */}
                {loading ? (
                    <div className="text-center py-4">
                        <span className="text-pink-500 text-2xl font-bold">
                            Loading...
                        </span>
                    </div>
                ) : (
                    <div className="px-10">
                        {filteredData.map((category) => (
                            <div key={category.id}>
                                {/* Category */}
                                <div className="flex items-center gap-2 py-3 border-b border-gray-400">
                                    <MdOutlinePlaylistAdd
                                        className="text-gray-600 text-2xl cursor-pointer"
                                        onClick={() =>
                                            handleShowAddSubCategory(
                                                category.id,
                                                category.name
                                            )
                                        }
                                    />
                                    <MdOutlineDelete
                                        className="text-gray-600 text-2xl cursor-pointer"
                                        onClick={() =>
                                            handleDelete("category", category.id, category.name)
                                        }
                                    />
                                    <FontAwesomeIcon
                                        icon={
                                            expandedCategoryId === category.id
                                                ? faMinus
                                                : faPlus
                                        }
                                        className="text-blue-600 border-2 border-blue-600 p-1 rounded-lg text-xs cursor-pointer"
                                        onClick={() => toggleExpand(category.id)}
                                    />
                                    <input
                                        type="checkbox"
                                        className="scale-150 cursor-pointer"
                                        checked={
                                            selectedItem === category.name
                                        }
                                        onChange={() =>
                                            handleSelect("category", category.id, category.name)
                                        }
                                    />
                                    {category.name}
                                </div>

                                {/* Subcategories */}
                                {expandedCategoryId === category.id && (
                                    <div className="py-3">
                                        {/* Add Subcategory Input */}
                                        {showAddSubCategory[category.id] && (
                                            <div className="flex items-center gap-5 mx-14">
                                                <input type="text" placeholder="Enter Sub Category name..."
                                                    className="border-gray-400 border p-2 rounded-2xl focus:outline-blue-500 w-3/5"
                                                    value={subcategoryName}
                                                    onChange={(e) => setSubCategoryName(e.target.value)} />
                                                <button
                                                    className="w-fit text-blue-700 bg-blue-200 py-2 px-4 rounded-lg flex items-center hover:bg-blue-400"
                                                    onClick={handleAddSubCategory}>
                                                    Add
                                                </button>
                                            </div>
                                        )}
                                        {category.subcategories.map((sub) => (
                                            <div key={sub.id} className="flex gap-3 py-2 px-14 items-center">
                                                <MdOutlineDelete
                                                    className="text-gray-600 text-2xl cursor-pointer"
                                                    onClick={() => handleDelete("subcategory", sub.id, sub.name)} />
                                                <input
                                                    type="checkbox"
                                                    className="scale-150 cursor-pointer"
                                                    checked={selectedItem === sub.name}
                                                    onChange={() => handleSelect("subcategory", sub.id, sub.name)}
                                                />
                                                <p className="w-full">{sub.name}</p>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
                {showDeletePopup && (
                    <DeleteCategoryPopUp
                        Datas={datas}
                        onCancel={() => setShowDeletePopup(false)}
                        onDelete={handleDeleteConfirm}
                    />
                )}
            </div>
        </div>
    );
};

export default SelectCategoryModal;
